angular.module('forms').directive('apFormAnswerNumeric',
    ['$rootScope',
        function ($rootScope) {
            'use strict';

            return {
                restrict: 'E',
                templateUrl: '/forms/views/directives/apFormAnswerNumeric.html',
                scope: {
                    // Use '@' for one way binding.  String value is returned.
                    // Use '=' for two way binding.  An object is returned.
                    // Use '&' for a method.
                    question: '=question',
                    answers: '=answers',
                    lastQuestion: '@lastQuestion'
                },
                controller: function($scope) {

                    function updateEnteredAnswer() {
                        var answerText = String($scope.question.SelectedAnswerText);
                        if (answerText === 'undefined') {
                            answerText = '';
                            $scope.question.SelectedAnswerText = '';
                        }
                        $scope.question.SelectedAnswerId = '00000000-0000-0000-0000-000000000000';

                        if (answerText.length > 0) {
                            _.forEach($scope.answers, function(answer) {
                                if (answer.SurveyAnswerLabel === answerText) {
                                    $scope.question.SelectedAnswerId = answer.SurveyAnswerId;
                                }
                            });

                            $scope.question.SelectedAnswerText = Number($scope.question.SelectedAnswerText);
                        }
                    }


                    function enableQuestionsForSelectedAnswer(enableQuestion, answerText) {
                        _.forEach($scope.answers, function(answer) {
                            _.forEach(answer.QuestionsToTrigger, function(questionToEnable) {
                                var fireEvent = false;

                                if (questionToEnable !== '00000000-0000-0000-0000-000000000000') {
                                    if (enableQuestion) {
                                        if (answer.SurveyAnswerLabel === answerText) {
                                            fireEvent = true;
                                        }
                                    } else {
                                        fireEvent = true;
                                    }
                                }

                                if (fireEvent === true) {
                                    $rootScope.$broadcast('FormAnswerChanged',
                                        {
                                            EnableQuestion: enableQuestion,
                                            QuestionIdToTrigger: questionToEnable
                                        });
                                }
                            });
                        });
                    }


                    $scope.answerChanged = function answerChanged() {
                        updateEnteredAnswer();

                        var enableQuestion = false;
                        if ($scope.question.SelectedAnswerText > 0) {
                            enableQuestion = true;
                        }

                        enableQuestionsForSelectedAnswer(enableQuestion, $scope.question.SelectedAnswerText);
                    };


                    function loadView() {
                        updateEnteredAnswer();
                    }
                    loadView();
                }
            };
        }
    ]
);